import {
    ADMIN_STATS_REQUEST, ADMIN_STATS_SUCCESS, ADMIN_STATS_FAIL,
    ADMIN_STORES_REQUEST, ADMIN_STORES_SUCCESS, ADMIN_STORES_FAIL,
    ADMIN_STORE_MUTATE_REQUEST, ADMIN_STORE_MUTATE_SUCCESS, ADMIN_STORE_MUTATE_FAIL, ADMIN_STORE_MUTATE_RESET,
    ADMIN_USERS_REQUEST, ADMIN_USERS_SUCCESS, ADMIN_USERS_FAIL,
    ADMIN_USER_MUTATE_REQUEST, ADMIN_USER_MUTATE_SUCCESS, ADMIN_USER_MUTATE_FAIL, ADMIN_USER_MUTATE_RESET,
    PRICE_BOOK_REQUEST, PRICE_BOOK_SUCCESS, PRICE_BOOK_FAIL,
    PRICE_BOOK_MUTATE_REQUEST, PRICE_BOOK_MUTATE_SUCCESS, PRICE_BOOK_MUTATE_FAIL, PRICE_BOOK_MUTATE_RESET,
    PRICE_BOOK_IMPORT_REQUEST, PRICE_BOOK_IMPORT_SUCCESS, PRICE_BOOK_IMPORT_FAIL, PRICE_BOOK_IMPORT_RESET,
    WHOLESALE_PRICE_BOOK_REQUEST, WHOLESALE_PRICE_BOOK_SUCCESS, WHOLESALE_PRICE_BOOK_FAIL,
    WHOLESALE_PRICE_BOOK_MUTATE_REQUEST, WHOLESALE_PRICE_BOOK_MUTATE_SUCCESS, WHOLESALE_PRICE_BOOK_MUTATE_FAIL, WHOLESALE_PRICE_BOOK_MUTATE_RESET,
    WHOLESALE_PRICE_BOOK_IMPORT_REQUEST, WHOLESALE_PRICE_BOOK_IMPORT_SUCCESS, WHOLESALE_PRICE_BOOK_IMPORT_FAIL, WHOLESALE_PRICE_BOOK_IMPORT_RESET,
    ADMIN_CLEAR_ERRORS,
} from "../constants/adminConstants";

export const adminStatsReducer = (state = {}, action) => {
    switch (action.type) {
        case ADMIN_STATS_REQUEST: return { loading: true };
        case ADMIN_STATS_SUCCESS: return { loading: false, ...action.payload };
        case ADMIN_STATS_FAIL: return { loading: false, error: action.payload };
        case ADMIN_CLEAR_ERRORS: return { ...state, error: null };
        default: return state;
    }
};

export const adminStoresReducer = (state = { stores: [] }, action) => {
    switch (action.type) {
        case ADMIN_STORES_REQUEST: return { loading: true, stores: [] };
        case ADMIN_STORES_SUCCESS: return { loading: false, stores: action.payload };
        case ADMIN_STORES_FAIL: return { loading: false, error: action.payload, stores: [] };
        case ADMIN_CLEAR_ERRORS: return { ...state, error: null };
        default: return state;
    }
};

export const adminStoreMutateReducer = (state = {}, action) => {
    switch (action.type) {
        case ADMIN_STORE_MUTATE_REQUEST: return { loading: true };
        case ADMIN_STORE_MUTATE_SUCCESS: return { loading: false, success: true, message: action.payload };
        case ADMIN_STORE_MUTATE_FAIL: return { loading: false, error: action.payload };
        case ADMIN_STORE_MUTATE_RESET: return {};
        case ADMIN_CLEAR_ERRORS: return { ...state, error: null };
        default: return state;
    }
};

export const adminUsersReducer = (state = { users: [] }, action) => {
    switch (action.type) {
        case ADMIN_USERS_REQUEST: return { loading: true, users: [] };
        case ADMIN_USERS_SUCCESS: return { loading: false, users: action.payload };
        case ADMIN_USERS_FAIL: return { loading: false, error: action.payload, users: [] };
        case ADMIN_CLEAR_ERRORS: return { ...state, error: null };
        default: return state;
    }
};

export const adminUserMutateReducer = (state = {}, action) => {
    switch (action.type) {
        case ADMIN_USER_MUTATE_REQUEST: return { loading: true };
        case ADMIN_USER_MUTATE_SUCCESS: return { loading: false, success: true, message: action.payload };
        case ADMIN_USER_MUTATE_FAIL: return { loading: false, error: action.payload };
        case ADMIN_USER_MUTATE_RESET: return {};
        case ADMIN_CLEAR_ERRORS: return { ...state, error: null };
        default: return state;
    }
};

export const priceBookReducer = (state = { items: [], totalPages: 1, total: 0 }, action) => {
    switch (action.type) {
        case PRICE_BOOK_REQUEST: return { ...state, loading: true };
        case PRICE_BOOK_SUCCESS: return { loading: false, items: action.payload.items, totalPages: action.payload.totalPages, total: action.payload.total, currentPage: action.payload.currentPage };
        case PRICE_BOOK_FAIL: return { ...state, loading: false, error: action.payload };
        case ADMIN_CLEAR_ERRORS: return { ...state, error: null };
        default: return state;
    }
};

export const priceBookMutateReducer = (state = {}, action) => {
    switch (action.type) {
        case PRICE_BOOK_MUTATE_REQUEST: return { loading: true };
        case PRICE_BOOK_MUTATE_SUCCESS: return { loading: false, success: true, message: action.payload };
        case PRICE_BOOK_MUTATE_FAIL: return { loading: false, error: action.payload };
        case PRICE_BOOK_MUTATE_RESET: return {};
        case ADMIN_CLEAR_ERRORS: return { ...state, error: null };
        default: return state;
    }
};

export const priceBookImportReducer = (state = { inserted: 0, skipped: 0 }, action) => {
    switch (action.type) {
        case PRICE_BOOK_IMPORT_REQUEST: return { loading: true, inserted: 0, skipped: 0 };
        case PRICE_BOOK_IMPORT_SUCCESS: return { loading: false, success: true, inserted: action.payload.inserted, skipped: action.payload.skipped };
        case PRICE_BOOK_IMPORT_FAIL: return { loading: false, error: action.payload, inserted: 0, skipped: 0 };
        case PRICE_BOOK_IMPORT_RESET: return { inserted: 0, skipped: 0 };
        case ADMIN_CLEAR_ERRORS: return { ...state, error: null };
        default: return state;
    }
};

export const wholesalePriceBookReducer = (state = { items: [], totalPages: 1, total: 0 }, action) => {
    switch (action.type) {
        case WHOLESALE_PRICE_BOOK_REQUEST: return { ...state, loading: true };
        case WHOLESALE_PRICE_BOOK_SUCCESS:
            return {
                loading: false,
                items: action.payload.items,
                totalPages: action.payload.totalPages,
                total: action.payload.total,
                currentPage: action.payload.currentPage,
            };
        case WHOLESALE_PRICE_BOOK_FAIL: return { ...state, loading: false, error: action.payload };
        case ADMIN_CLEAR_ERRORS: return { ...state, error: null };
        default: return state;
    }
};

export const wholesalePriceBookMutateReducer = (state = {}, action) => {
    switch (action.type) {
        case WHOLESALE_PRICE_BOOK_MUTATE_REQUEST: return { loading: true };
        case WHOLESALE_PRICE_BOOK_MUTATE_SUCCESS: return { loading: false, success: true, message: action.payload };
        case WHOLESALE_PRICE_BOOK_MUTATE_FAIL: return { loading: false, error: action.payload };
        case WHOLESALE_PRICE_BOOK_MUTATE_RESET: return {};
        case ADMIN_CLEAR_ERRORS: return { ...state, error: null };
        default: return state;
    }
};

export const wholesalePriceBookImportReducer = (state = { inserted: 0, skipped: 0 }, action) => {
    switch (action.type) {
        case WHOLESALE_PRICE_BOOK_IMPORT_REQUEST: return { loading: true, inserted: 0, skipped: 0 };
        case WHOLESALE_PRICE_BOOK_IMPORT_SUCCESS:
            return {
                loading: false,
                success: true,
                inserted: action.payload.inserted,
                skipped: action.payload.skipped,
            };
        case WHOLESALE_PRICE_BOOK_IMPORT_FAIL:
            return { loading: false, error: action.payload, inserted: 0, skipped: 0 };
        case WHOLESALE_PRICE_BOOK_IMPORT_RESET: return { inserted: 0, skipped: 0 };
        case ADMIN_CLEAR_ERRORS: return { ...state, error: null };
        default: return state;
    }
};
